import DataTable from 'react-data-table-component';
const customStyles = {
    rows: {
        style: {
            minHeight: '72px', // override the row height
        },
    },
    headCells: {
        style: {
            fontSize: '5rem', // override the cell padding for head cells
            backgroundColor: 'var(--bg-base-color)',
            color: 'var(--base-white)',

        },
    },
    cells: {
        style: {
            paddingLeft: '8px', // override the cell padding for data cells
            paddingRight: '8px',
        },
    },
    contextMenu: {
        style: {
            fontSize: '18px',
            fontWeight: 400,
            paddingLeft: '16px',
            paddingRight: '8px',
            transform: 'translate3d(0, -100%, 0)',
            transitionDuration: '125ms',
            transitionTimingFunction: 'cubic-bezier(0, 0, 0.2, 1)',
            willChange: 'transform',
            backgroundColor: 'red'
        },
        activeStyle: {
            transform: 'translate3d(0, 0, 0)',
        },
    },
};

const paginationComponentOptions = {
    selectAllRowsItem: true,
    selectAllRowsItemText: 'Todos',
    noRowsPerPage: false,
    paginationPerPage: 5,
};
const conditionalRowStyles = [
    {
        when: row => row.toggleSelected,
        style: {
            backgroundColor: "#EEEEEE",
            userSelect: "none",
            color: "#000300",
            border: "none",
        }
    }
];

import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { loaderAction } from '../redux/actions/Index';
import { environment } from './../env';
import axios from 'axios';
import LoadBox from './Loading/LoadBox';

const Table = ({ columns, data, setPageno, selectedProject, ctent, investors, selTenant, setRecord, inves, resell, query, getInvestorProperties, update, showProperties, propertiesDetail, documentDetails, tenant, soldGala, tog, groupid, pageinationProp}) => {
    const loader = useSelector((state) => state.ModalReducer?.loader)
    const dispatch = useDispatch()
    const [tableData, setTableData] = useState(data)
    const [pending, setPending] = React.useState(true);
    useEffect(() => {
        const timeout = setTimeout(() => {
            setPending(false);
        }, 500);
        return () => clearTimeout(timeout);
    }, []);


    const Test = (propertiesData) => {
        dispatch(loaderAction());
        const SoldGalaDocPayLoad = new FormData();
        SoldGalaDocPayLoad.append("Investors", propertiesData?.Investors.id);
        SoldGalaDocPayLoad.append("gala", propertiesData?.gala.id);
        try {
            axios.post(`${environment.baseUrl}investors-properties-with-doc/`, SoldGalaDocPayLoad).then((docresponse) => {
                documentDetails(docresponse.data);
                dispatch(loaderAction());
            });
            showProperties(true);
        } catch (err) {
            dispatch(loaderAction());
            console.log(err);
        }
    };

    const getTenant = (data) => {
        try {
            axios.get(`${environment.baseUrl}tenant-gala-filter/?proposal=&building=&project=${data}`).then((res) => {
                tenant(res.data)
                dispatch(loaderAction());
            });
            showProperties(true);
        } catch (err) {
            dispatch(loaderAction());
            console.log(err);
        }
    }

    const handleRowClicked = row => {
        if (inves != undefined) {
            if (resell != undefined) {
                propertiesDetail(row)
            } else {
                Test(row)
                // getTenant(row.project.name)
                propertiesDetail(row)
            }
        } else if (ctent != undefined) {
            selTenant(row)
            showProperties(true);
        } else if (soldGala == true) {
            if (row.ownertype == "Joined") {
                tog(true)
                groupid(row.group_id)
            }
        }
        else {
            selectedProject(row.Investors.id)
            update(true)
            getInvestorProperties(row.Investors.id)
        }

        if (query != undefined) {
            query();
        }


        const updatedData = tableData.map(item => {

            item.toggleSelected = false;
            if (row.id !== item.id) {
                return item;
            }
            return {
                ...item,
                toggleSelected: true
            };
        });

        setTableData(updatedData);
    };

    useEffect(() => {
        setTableData(data);
    }, [data])

    const func = (page, totalRows) => {
        if (investors == true) {
            setPageno(page)
        } 
    }

    const funcc = (data) => {
        console.log("REcords");
        if (investors == true) {
            setRecord(data)
        } 

    }

    return (
        <DataTable
            customStyles={customStyles}
            columns={columns}
            data={tableData}
            onRowClicked={handleRowClicked}
            highlightOnHover
            progressPending={pending}
            progressComponent={<LoadBox />}
            pagination={pageinationProp ? false : true}
            paginationPerPage={9}
            paginationRowsPerPageOptions={[8, 10, 15, 25, 50]}
            onChangePage={(page, totalRows) => { func(page, totalRows) }}
            onChangeRowsPerPage={funcc}
            paginationComponentOptions={{
                rowsPerPageText: 'Records per page:',
                rangeSeparatorText: 'out of',
            }}
            activeStyle={{ backgroundColor: 'red' }}
            conditionalRowStyles={conditionalRowStyles}
        />
    )
}

export default Table